
import ExpertiseTile from "../../../common/expertise/ExpertiseTile";

export default function Expertise({ expertise, isDesktop, index = 0 }) {
	return (
		<ExpertiseTile
			expertise={expertise}
			isDesktop={isDesktop}
			index={index}
			to={`/workshop_list/?expertise_id=${expertise.id}`}
		/>
	);
}
